import api from './axiosService';

export const capitalApi = {
    getAll(params = {}) {
        return api.get('/capitals', { params });
    },

    getById(capitalId) {
        return api.get(`/capitals/${capitalId}`);
    },

    getByShop(shopId) {
        return api.get(`/capitals/shop/${shopId}`);
    },

    getAllByShop(shopId, params = {}) {
    return api.get(`/capitals/shop/${shopId}`, { params });
},

    getTotalByShop(shopId) {
        return api.get(`/capitals/shop/${shopId}/total`);
    },

    getByDateRange(params = {}) {
        return api.get('/capitals/by-date-range', { params });
    },

    create(data) {
        return api.post('/capitals', data);
    },

    update(capitalId, data) {
        return api.put(`/capitals/${capitalId}`, data);
    },

    toggleStatus(capitalId) {
        return api.patch(`/capitals/${capitalId}/toggle-status`);
    },

    delete(capitalId) {
        return api.delete(`/capitals/${capitalId}`);
    },
};